import React, { useState, useEffect, useRef } from 'react';
import { Box, Grid, TextField, Button, Dialog, DialogContent, Typography, DialogTitle, DialogActions, IconButton } from "@mui/material";
import varunLogo from '../../src/logo-varun.svg';
import VitelLogo from '../../src/logo-vitel.svg';
import axios from 'axios';
import { CheckCircle, Close, CloudUploadOutlined, ErrorOutline, Delete, AirlineSeatIndividualSuiteSharp } from '@mui/icons-material';
import DataTable from 'react-data-table-component';
import { useForm } from 'react-hook-form';
import { Stack } from "react-bootstrap";
import confetti from "canvas-confetti";
import { Navigate, useFormAction, useNavigate } from 'react-router-dom';
import ConfettiComponent from './Confetti';
import { IconFileText, IconTrash, IconX } from '@tabler/icons-react';
// import winSound from '.././soundnogap.wav';
import musicFile from '.././wheel-spin.wav';
// import musicFile from '.././audio1.mp3';
import winSound from '.././Awards1.mp3';
const WheelSpinner = () => {
    const [items, setItems] = useState([]);
    const [choosenHistory, setChoosenHistory] = useState([]);
    const [currentDeg, setCurrentDeg] = useState(0);
    const [theChoosen, setTheChoosen] = useState('');
    const [isResultModalOpen, setIsResultModalOpen] = useState(false);
    const [isInputModalOpen, setIsInputModalOpen] = useState(false);
    const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
    const [importModalOpen, setimportModalOpen] = useState(false);
    const wheelRef = useRef(null);
    const navigate = useNavigate();
    const { register, handleSubmit, formState: { errors }, getValues } = useForm();
    var colors = ['#5e4fa2', '#3288bd', '#66c2a5', '#abdda4', '#b2c742', '#c7c754', '#fee08b', '#fdae61', '#f46d43'];
    const audioRef = useRef(new Audio('.././music.mp3'));
    useEffect(() => {
        init();
    }, [items]);
    const columns = [
        {
            name: <Typography variant="subtitle2" fontWeight={600}>Full Name</Typography>, selector: (row) => row.name, cell: row =>
                <>
                    <div className="DarkBlue4_Color font_weight_300 font_14 align-middle align-middle">
                        <span>{row.name}</span>
                    </div>
                </>,
        },
        {
            name: <Typography variant="subtitle2" fontWeight={600}>Email</Typography>, selector: (row) => row.email, cell: row =>
                <>
                    <div className="DarkBlue4_Color font_weight_300 font_14 align-middle">
                        {row.email ? row.email : ""}
                    </div>
                </>
        },
        {
            name: <Typography variant="subtitle2" fontWeight={600}>Phone Number</Typography>, selector: (row) => row.phone, cell: row =>
                <>
                    <div className="DarkBlue4_Color font_weight_300 font_14 align-middle">{row.phone ? row.phone : ""}</div>
                </>,
        },
        {
            name: <Typography variant="subtitle2" fontWeight={600}>Company Name</Typography>, selector: (row) => row.company_name
            , cell: row =>
                <>
                    <div className="DarkBlue4_Color font_weight_300 font_14 align-middle">
                        {row.company_name ? row.company_name : ""}
                    </div>
                </>,
        },
    ];
    const historyColumns = [
        {
            name: <Typography variant="subtitle2" fontWeight={600}>FullName</Typography>, selector: (row) => row.name ,cell: row =>
                <>
                    <div className="DarkBlue4_Color font_weight_300 font_14 align-middle align-middle">
                        <span>{row.name}</span>
                    </div>
                </>,
        },
        {
            name: <Typography variant="subtitle2" fontWeight={600}>Email</Typography> ,selector: (row) => row.email, cell: row =>
                <>
                    <div className="DarkBlue4_Color font_weight_300 font_14 align-middle">
                        {row.email ? row.email : ""}
                    </div>
                </>
        },
        {
            name: <Typography variant="subtitle2" fontWeight={600}>Phone Number</Typography>, selector: (row) => row.phone_number ,cell: row =>
                <>
                    <div className="DarkBlue4_Color font_weight_300 font_14 align-middle">{row.phone_number ? row.phone_number : ""}</div>
                </>,
        },
        {
            name: <Typography variant="subtitle2" fontWeight={600}>Company Name</Typography>, selector: (row) => row.company_name
            , cell: row =>
                <>
                    <div className="DarkBlue4_Color font_weight_300 font_14 align-middle">
                        {row.company_name ? row.company_name : ""}
                    </div>
                </>,
        },
    ];
    const init = () => {
        if (items.length === 0) {
            const wheel = wheelRef.current;
            wheel.innerHTML = '';
            document.getElementById('spin-action').disabled = true
            return;
        }
        if (items.length !== 0) {
            const degPerPart = 360 / items.length;
            const wheel = wheelRef.current;
            document.getElementById('spin-action').disabled = false
            wheel.innerHTML = '';
            for (let i = 0; i < items.length; i++) {
                const part = document.createElement('div');
                part.className = 'part';
                part.style.backgroundColor = colors[i % colors.length];

                if (items.length === 1) {
                    part.innerHTML = `<div class="name">${items[0].name}</div>`;
                    part.style.height = '100%';
                    part.style.width = '100%';
                    part.style.backgroundColor = items[0].color;
                    part.style.clipPath = 'none';
                    part.style.transform = 'none';
                    part.style.top = '0';
                } 
                else if (items.length === 2) {
                    const colors = ['#FF5733', '#33FF57']; 
                    console.log(items[i].color,'colors');
                    part.innerHTML = `<div class="name">${items[i].name}</div>`;
                    part.style.height = '100%';
                    part.style.width = '50%';
                    part.style.backgroundColor = colors;
                    part.style.clipPath = `polygon(50% 0%, 90% 20%, 100% 60%, 75% 100%, 25% 100%, 0% 60%, 10% 20%);`; 
                    part.style.transform = `rotate(${i * 180}deg)`;
                }
                else {
                    part.innerHTML = `<div class="name">${items[i].name}</div>`;
                    part.style.height = items.length === 2 ? '100%' : `${Math.tan((degPerPart / 2) * Math.PI / 180) * 100}%`;
                    part.style.transform = items.length === 2 ? `rotate(${i * degPerPart}deg)` : `translateY(-50%) rotate(${i * degPerPart * -1}deg)`;
                    part.style.clipPath = 'polygon(0 0, 0 100%, 100% 50%)';
                    part.style.top = '50%';
                    part.style.backgroundColor = items[i].color;
                }


                wheel.appendChild(part);
            }
        }
    };
    useEffect(() => {
        fetchData();
    }, []);
    const [currentPage, setCurrentPage] = useState(1); 
    const [rowsPerPage, setRowsPerPage] = useState(10); 
    const paginatedData = items.slice((currentPage-1) * rowsPerPage, currentPage * rowsPerPage);
    const handlePerRowsChange = async (newPerPage) => {
        setRowsPerPage(newPerPage);
    };
    const fetchData = async () => {
        try {
            const params = {};
            if (StartDate) {
                params.start_date = StartDate;
            }
            if (EndDate) {
                params.end_date = EndDate;
            }
            if (startTime) {
                params.start_time = startTime;
            }
            if (endTime) {
                params.end_time = endTime;
            }
            const response = await axios.get('/apiV1/entries/?is_active=True&is_deleted=False&ordering=-updated_at', { params });
            const data = response.data;
            const validEmailsAndPhones = data.filter((item) => item.id !== null && item.email !== null && item.phone !== null && item.name !== null && item.comapny_name !== null)
                .map((item) => ({ id: item.id, email: item.email, phone: item.phone_number, name: item.name, company_name: item.company_name }));
            setItems(validEmailsAndPhones);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const fetchwinnerData = async () => {
        try {
            const response = await axios.get(`/apiV1/entries/?winner=True&is_active=True&is_deleted=False&ordering=-updated_at`);
            const data = response.data;
            const filteredData = data.filter(entry =>
                entry.name !== null ||
                entry.email !== null ||
                entry.phone_number !== null ||
                entry.company_name !== null 
            );
            setChoosenHistory(filteredData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    const [winaudio, setwinAudio] = useState(null);

    const playSound = () => {
        const newAudio = new Audio(musicFile);
        newAudio.loop = false; 
        newAudio.play();
        setTimeout(() => {
            newAudio.pause(); 
        }, 5000); 
    };
        const onSpin = () => {
            playSound()
            const newDeg = currentDeg + Math.floor(Math.random() * 360) + 360 * 10;
            setCurrentDeg(newDeg);
            const wheelElement = wheelRef.current;

            wheelElement.style.transition = 'transform 5s ease-out';
            wheelElement.style.transform = `rotate(${newDeg}deg)`;

            document.getElementById('spin-action').disabled = true;

            setTimeout(() => {
                const chosenItem = getTheChoosen(newDeg);
                setTheChoosen(chosenItem ? chosenItem : "");
                setIsResultModalOpen(true);
                document.getElementById('spin-action').disabled = false;
            }, 6000);
        };
        useEffect(() => {
            if (isResultModalOpen) {
                document.getElementById('hiddenPlayButton').click();
            } else {
                document.getElementById('hiddenPauseButton').click();
            }
        }, [isResultModalOpen]);
        
          const playWinSound = () => {
            if (winaudio) {
                winaudio.pause();
                winaudio.currentTime = 0;
            }
            
            const newAudio = new Audio(winSound);
            newAudio.loop = false; 
            newAudio.play()
                .then(() => {
                    setwinAudio(newAudio); 
                })
                .catch((error) => {
                    console.error('Error playing audio:', error);
                });
        };
    
        const pauseAudio = () => {
            if (winaudio) {
                winaudio.pause(); 
                setwinAudio(null);
            } else {
                console.log('No audio instance found to pause.');
            }
        };
      const handlepause =()=>
      {
        pauseAudio()
      }

        const handlePlayAudio = () => {
                playWinSound()
            }

    const getTheChoosen = (deg) => {
        const index = Math.ceil((deg % 360) / (360 / items.length) + 0.5) - 1;
        return items[index < 0 ? items.length - 1 : index];
    };

    const onInputData = () => {
        const inputData = document.getElementById('input-data').value;
        if (inputData) {
            const newItems = inputData.split('\n').filter(item => item.trim());
            setItems(newItems);
            setIsInputModalOpen(false);
        }
    };
    const openInputModal = () => {
        setIsInputModalOpen(true);
    };


    const onRemoveTheChoosen = () => {
        const newItems = items.filter((_, index) => index !== items.indexOf(theChoosen));
        setItems(newItems);
        setIsResultModalOpen(false);
    };

    const onViewHistory = () => {
        setIsHistoryModalOpen(true);
    };
    const winnerpost = () => {
        axios.patch(`/apiV1/winner/${theChoosen.id}/`).then((response) => {
            console.log(response.data);
        })
    }
    useEffect(() => {
        if (theChoosen.id) {
            winnerpost()
        }
    }, [theChoosen]);
    const confettiDelay = 350;
    const modalChangeDelay = 300;

    useEffect(() => {
        if (isResultModalOpen) {
            setTimeout(fireConfetti, confettiDelay);
        }
    }, [isResultModalOpen]);

    function fireConfetti() {
        var count = 200;
        var defaults = {
            origin: { y: 0.45 },
            gravity: 0.7,
            zIndex: 20
        };

        function fire(particleRatio, opts) {
            confetti(
                Object.assign({}, defaults, opts, {
                    particleCount: Math.floor(count * particleRatio),
                    colors: [
                        "#FFF",
                        "#14BB69",
                        "#50BAE2",
                        "#A4FFF5",
                        "#FFBF28",
                        "#FF5447"
                    ]
                })
            );
        }

        fire(0.25, { spread: 26, startVelocity: 55 });
        fire(0.2, { spread: 60 });
        fire(0.35, { spread: 100, decay: 0.91, scalar: 0.8 });
        fire(0.1, { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 });
        fire(0.1, { spread: 120, startVelocity: 45 });
    }
    const [StartDate, setStartDate] = useState('');
    const [EndDate, setEndDate] = useState('');
    const [startTime, setStartTime] = useState('');
    const [endTime, setendTime] = useState('');
    console.log(StartDate, EndDate);
    useEffect(() => {
        if (startTime && endTime) {
            fetchData(startTime, endTime);
        }
    }, [startTime, endTime]);
    useEffect(() => {
        if (StartDate && EndDate) {
            fetchData(StartDate, EndDate);
        }
    }, [StartDate, EndDate]);
    const [open, setOpen] = useState(false);
    const [file, setFile] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorjdMessage, setErrorjdMessage] = useState('');
    const handleClose = () => {
        setOpen(false);
        setimportModalOpen(false);
        setFile(null);
        setErrorjdMessage('');
    };
    const handleJdSubmit = (data) => {
        console.log(data, 'data from api');

    };
    const handleOpen = () => {
        setOpen(true);
    };
    const [importFile, setimportFile] = useState('');
    const handleFileChange = (event) => {
        const filesd = Array.from(event.target.files);
        setimportFile(filesd);
        const selectedFile = event.target.files[0];
        const validFileTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv'];
        if (selectedFile && validFileTypes.includes(selectedFile.type)) {
            setFile(selectedFile);
            setErrorjdMessage('');
        } else {
            setErrorjdMessage('Please upload a valid file (.xlsx or .csv).');
            setFile(null);
        }
    };

    const handleDeleteFile = () => {
        setFile(null);
    };
    const handleDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const droppedFiles = event.dataTransfer.files;
        if (droppedFiles.length > 0) {
            setFile(droppedFiles[0]);
        }
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        event.stopPropagation();
    };
    const onSubmit = (data) => {
        const formData = new FormData();
        formData.append("file", importFile[0]);
        axios.post('/apiV1/raffle-entries/import/', formData)
            .then((response) => {
                console.log(response.data);
                fetchData();
                setFile(null);
                setimportModalOpen(false)
            })
            .catch((error) => {
                console.error('Error uploading file:', error);
            });
    }
    const [deletedids, setDeletedIds] = useState();
    const [deleteModalOpen, setdeleteModalOpen] = useState(false);
    const [deletesucessModal,setdeletesucessModal]=useState(false)
    const [selectedRows, setSelectedRows] = useState([]);
    console.log(selectedRows,'selectedrows');
    
    const onDeleterow = (row) => {
        setSelectedRows(row);
        setDeletedIds(row.join(','));
    }
    const handleDelete = () => {
        const response =axios.delete('/apiV1/entries/delete/', {
            data: {
                ids: deletedids
            }
        });
        setSelectedRows([]);
        setdeleteModalOpen(false)
        setdeletesucessModal(true)  
        setDeletedIds([])
        fetchData();
    }
    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: 'All',
    };

    return (
        <Box>
            <Grid container justifyContent="center" alignItems="center" spacing={2} className="my-3 slogo" sx={{ mt: 1 }}>
                <Grid item xs={6} sm={3}>
                    <img src={VitelLogo} alt="Vitel Logo" style={{ maxWidth: '100%' }} />
                </Grid>
                <Grid item xs={6} sm={2} style={{ textAlign: 'right' }}>
                    <img src={varunLogo} alt="Varun Logo" className="v_logo" style={{ maxWidth: '85%' }} />
                </Grid>
            </Grid>

            <Box display="flex" alignItems="center" justifyContent="center" width="100%" sx={{ mt: 2 }}>
                <Box className="wheel-wrapper" id="wheel">
                    <Box id="wheel-container">
                        <Box id="wheel" ref={wheelRef}></Box>
                        <Button variant="contained" color="primary" id="spin-action" onClick={onSpin}>
                            Spin
                        </Button>
                        <Box className="marker"></Box>
                    </Box>

                    <Grid container spacing={2} justifyContent="space-between" alignItems="center" mt={4}>
                        <Grid item>
                            <Button variant="contained" color="primary" onClick={() => { openInputModal();fetchData() }} sx={{ textTransform: "none" }}>
                                Manage
                            </Button>

                        </Grid>
                        <Grid item>
                            <Button variant="contained" sx={{ backgroundColor: "#65c2a5", textTransform: "none" }} onClick={() => { window.location.reload() }}>
                                Refresh
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button variant="contained" color="secondary" onClick={() => { onViewHistory(); fetchwinnerData() }} sx={{ textTransform: "none" }}>
                                Winners
                            </Button>
                        </Grid>
                    </Grid>
                    {/* <Button variant="contained" color="secondary" onClick={() => navigate('/frame1')}>
                        frame1
                    </Button> */}
                </Box>
                <Dialog
                    open={isResultModalOpen}
                    aria-labelledby="success-dialog-title"
                    maxWidth="md"
                    fullWidth
                    BackdropProps={{
                        style: {
                            backgroundColor: 'transparent',
                        },
                    }}
                    sx={{ mt: '4rem' }} 
                >
                    <DialogContent dividers className='text-center py-3' sx={{
                        backgroundImage: `url(https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT4WSsfeyQ_TrcV7UapK8g3T-tajNgl8z4Pw5u3OGlnvA4ZRqNR0Kx7ELiOAS39_Fl8bH8&usqp=CAU)`,
                        backgroundSize: 'cover',  // Cover the whole Dialog
                        backgroundPosition: 'center',  // Center the background
                        backgroundRepeat: 'no-repeat',  // No repeat for the image
                        textAlign: 'center',
                        padding: '3rem'
                    }}>
                        <Box className='text-success font_54' sx={{ textAlign: "center", color: "green" }}>
                            {/* <img src={Congrats} alt="Congrats" style={{ maxWidth: '100%' }} /> */}
                            <CheckCircle sx={{ color: "green", fontSize: "150px" }} />
                            <Typography variant="h2" className='blue_dark_text font_weight_700 mt-1'>
                                Congratulations!
                            </Typography>
                        </Box>
                        <Typography variant="h5" className='blue_dark_text font_weight_700 mt-1 text-center' sx={{ textAlign: "center" }}>
                            You're the lucky winner of our raffle! Well done!
                        </Typography>
                        <Box sx={{ mt: 2 }} textAlign={"center"}>
                            <Typography variant="h3" >{theChoosen?.name}</Typography>
                            <Typography variant="h3">{theChoosen?.company_name}</Typography>
                            <Typography variant="h3">{theChoosen?.email}</Typography>
                            <Typography variant="h3">{theChoosen?.phone}</Typography>
                        </Box>
                    </DialogContent>
                    <DialogActions sx={{
                        backgroundImage: `url(https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT4WSsfeyQ_TrcV7UapK8g3T-tajNgl8z4Pw5u3OGlnvA4ZRqNR0Kx7ELiOAS39_Fl8bH8&usqp=CAU)`,
                        backgroundSize: 'cover',  // Cover the whole Dialog
                        backgroundPosition: 'center',  // Center the background
                        backgroundRepeat: 'no-repeat',  // No repeat for the image
                        textAlign: 'center',
                    }}>
                        <Button onClick={() => {setIsResultModalOpen(false); onSpin()}} id="spin-action" sx={{ backgroundColor: "#da3744", color: "#fff", textTransform: "none" }}>
                            Next
                        </Button>
                        <Button onClick={() => {setIsResultModalOpen(false); pauseAudio()}} sx={{ backgroundColor: "#6d747d", color: "#fff", textTransform: "none" }}>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={isInputModalOpen} onClose={(event, reason) => { if (reason !== "backdropClick") { setIsInputModalOpen(false) } }} fullWidth maxWidth="lg">
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                        <DialogTitle>Participants</DialogTitle>
                        <Box display="flex" justifyContent="flex-end">
                            <Button variant="contained" color="error" sx={{ mr: 2, textTransform: "none" }} onClick={() => setdeleteModalOpen(true)} disabled={selectedRows.length === 0}>
                                Delete
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                sx={{ mr: 2, textTransform: "none" }}
                                onClick={() => setimportModalOpen(true)}
                            >
                                Import
                            </Button>
                        </Box>
                    </Box>

                    <DialogContent>
                        <Box sx={{ display: "flex", flexDirection: "row", gap: 2, mt: 2 }}>
                            <TextField
                                id="start-date"
                                type="date"
                                fullWidth
                                size="small"
                                label="Start Date"
                                variant="outlined"
                                className='hidemobilescreen'
                                InputLabelProps={{ shrink: true }}
                                error={!!errors.startDate}
                                value={StartDate}
                                helperText={errors.startDate ? 'Start Date is required' : ''}
                                onChange={(e) => {
                                    setStartDate(e.target.value);
                                    if (EndDate && new Date(EndDate) < new Date(e.target.value)) {
                                        setEndDate('');
                                    }
                                }}
                                inputProps={{
                                    max: new Date().toISOString().split('T')[0],
                                }}
                            />

                            <TextField
                                id="end-date"
                                type="date"
                                fullWidth
                                size="small"
                                label="End Date"
                                variant="outlined"
                                value={EndDate}
                                className='hidemobilescreen'
                                InputLabelProps={{ shrink: true }}
                                error={!!errors.endDate}
                                helperText={errors.endDate ? 'End Date is required' : ''}
                                onChange={(e) => setEndDate(e.target.value)}
                                inputProps={{
                                    min: StartDate,
                                    max: new Date().toISOString().split('T')[0],
                                }}
                            />

                            {/* Start Time */}
                            <TextField
                                id="start-time"
                                type="time"
                                fullWidth
                                size="small"
                                label="Start Time"
                                variant="outlined"
                                className='hidemobilescreen'
                                InputLabelProps={{ shrink: true }}
                                value={startTime}
                                error={!!errors.startTime}
                                helperText={errors.startTime ? 'Start Time is required' : ''}
                                onChange={(e) => setStartTime(e.target.value)}

                            />

                            {/* End Time */}
                            <TextField
                                id="end-time"
                                type="time"
                                fullWidth
                                size="small"
                                label="End Time"
                                variant="outlined"
                                value={endTime}
                                className='hidemobilescreen'
                                InputLabelProps={{ shrink: true }}
                                error={!!errors.endTime}
                                helperText={errors.endTime ? 'End Time is required' : ''}
                                onChange={(e) => setendTime(e.target.value)}

                            />

                        </Box>
                        <DataTable
                            fixedHeader
                            fixedHeaderScrollHeight='550px'
                            fixedHeaderScrollWidth='50px'
                            columns={columns}
                            data={paginatedData}
                            pagination
                            paginationPerPage={rowsPerPage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            paginationServer
                            paginationTotalRows={items.length}
                            onChangePage={(page) => setCurrentPage(page)} 
                            highlightOnHover
                            pointerOnHover
                            selectableRows
                            paginationComponentOptions={paginationComponentOptions}
                            onSelectedRowsChange={(selectedRows) =>
                                onDeleterow(selectedRows.selectedRows.map((participant) => participant.id))
                            }
                            selectedRows={selectedRows}
                            />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setIsInputModalOpen(false) ;setSelectedRows([])}} sx={{ backgroundColor: "#da3744", color: "#fff", textTransform: 'none' }}>Close</Button>
                        <Button onClick={() => { setIsInputModalOpen(false); init() ;setSelectedRows([])}} sx={{ backgroundColor: "#1982c4", color: "#fff", textTransform: 'none' }}>Save</Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={isHistoryModalOpen} onClose={() => setIsHistoryModalOpen(false)} fullWidth maxWidth="lg">
                    <DialogTitle>Winner's History</DialogTitle>
                    <DialogContent>
                        <DataTable
                            columns={historyColumns}
                            data={choosenHistory}
                            fixedHeader
                            fixedHeaderScrollHeight='550px'
                            fixedHeaderScrollWidth='50px'
                            pagination 
                            paginationComponentOptions={paginationComponentOptions}/>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setIsHistoryModalOpen(false)} sx={{ backgroundColor: "#da3744", color: "#fff", textTransform: 'none' }}>Close</Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={importModalOpen} onClose={() => setimportModalOpen(false)} fullWidth maxWidth="md">
                    <DialogContent>
                        <Stack className='uploadTextClose'>
                            <Box alignItems="center" justifyContent="space-between" sx={{ display: 'flex', width: '100%', gap: 2 }} >
                                <Typography variant="h5" mb={2} fontWeight={600} fontSize='20px'>
                                    Upload File
                                </Typography>
                                <Typography variant="h5" mb={2} fontWeight={400} onClick={!isSubmitting ? handleClose : undefined}>
                                    <IconX />
                                </Typography>
                            </Box>
                        </Stack>
                        <Stack
                            onClick={!isSubmitting ? () => document.getElementById('uploadPdfFiles').click() : undefined} fclassName={`uploadFileClass ${isSubmitting ? 'disabled' : ''}`}
                            onDrop={handleDrop}
                            onDragOver={handleDragOver}
                        >
                            <Box sx={{ textAlign: 'center', border: '2px dashed #ccc', padding: '20px', borderRadius: '4px', cursor: 'pointer' }}>

                                <CloudUploadOutlined sx={{ fontSize: '48px', color: '#9e9e9e' }} />
                                <input
                                    type="file"
                                    {...register("file")}
                                    id="uploadPdfFiles"
                                    accept=".csv, .xlsx"
                                    onChange={handleFileChange}
                                    style={{ display: 'none' }}
                                    disabled={isSubmitting}
                                />
                                <Typography>
                                    Drag & drop or <span style={{ color: '#3f51b5', fontWeight: 'bold' }}>Choose file</span> to upload
                                </Typography>
                                <Typography variant="body2" sx={{ mt: 1 }}>
                                    Eg: (csv, xlsx)
                                </Typography>
                            </Box>
                        </Stack>

                        {file && (
                            <Box className="filesNameClass d-flex" sx={{ margin: "10px 0px 0px 0px", display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <IconFileText size={48} style={{ color: '#4da864', marginRight: '10px' }} />
                                    <Box>
                                        <Typography>{file.name}</Typography>
                                        <Typography> {Math.round(file.size / 1024)} KB</Typography>
                                    </Box>
                                </Box>
                                <IconButton onClick={handleDeleteFile}>
                                    <IconTrash size={30} style={{ color: '#f75454' }} />
                                </IconButton>
                            </Box>

                        )}
                    </DialogContent>
                    {errorjdMessage && (
                        <Typography variant="body2" sx={{ color: 'red', ml: 3 }}>
                            {errorjdMessage}
                        </Typography>
                    )}
                    <DialogActions>
                        <Button onClick={handleClose} variant='contained' color="warning" disabled={isSubmitting} sx={{ textTransform: 'none' }}>Cancel</Button>
                        <Button variant="contained" disabled={!file || isSubmitting} onClick={handleSubmit(onSubmit)} sx={{ textTransform: 'none' }}>Import</Button>
                    </DialogActions>
                </Dialog>
                {/* {isResultModalOpen && <ConfettiComponent />} */}
                {isResultModalOpen &&
                    <Box sx={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 999 }}>
                        <ConfettiComponent />
                    </Box>
                }
                <Dialog
                    open={deleteModalOpen}
                    onClose={handleClose}
                    aria-labelledby="delete-dialog-title"
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle id="delete-dialog-title">Are you sure?</DialogTitle>
                    <DialogContent>
                        <Typography variant="body1">
                            Are you sure you want to delete this entry?
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" color="primary" onClick={handleDelete}>
                            Yes
                        </Button>
                        <Button variant="contained" color="secondary" onClick={() => setdeleteModalOpen(false)}>
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={deletesucessModal}
                    aria-labelledby="success-dialog-title"
                    aria-describedby="success-dialog-description"
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle id="success-dialog-title" className='bg-my-primary p-3 font_weight_700'>
                        Success
                    </DialogTitle>
                    <DialogContent dividers className='text-center py-3'>
                        <Box className='text-success font_54'>
                            <CheckCircle fontSize="large" />
                        </Box>
                        <Typography variant="h6" className='blue_dark_text font_weight_700 mt-1'>
                            Deleted successfully
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Box display="flex" justifyContent="end" width="100%" mb={2}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    setdeletesucessModal(false);
                                    fetchData();
                                }}
                            >
                                Okay
                            </Button>
                        </Box>
                    </DialogActions>
                </Dialog>
            </Box>
                    <button
                id="hiddenPlayButton"
                style={{ display: 'none' }} // Hide the button
                onClick={handlePlayAudio}
            >
            </button>
            <button
                id="hiddenPauseButton"
                style={{ display: 'none' }} 
                onClick={handlepause}
            >
            </button>
        </Box>
    );
};

export default WheelSpinner;
